import { Link } from 'react-router-dom'
import { IonAvatar, IonBadge, IonButton, IonCard, IonCardContent, IonCol, IonIcon, IonImg, IonLabel, IonRippleEffect, IonRow, IonText } from "@ionic/react"
import { calendarOutline, chevronBack, handRightOutline, heartOutline, leafOutline, locationOutline, mailOutline, waterOutline } from "ionicons/icons"

import './CampaignItem.css';
import ProgressBar from './ProgressBar';
import Image from '../image/Image';
import { table } from 'console';
import DownloadDoc from './DownloadDoc';

interface Props {
    id: number,
    type: string,
    image: string,
    title: string,
    currentPrice: string,
    targetPrice: string,
    progress: number,
    link: string,
    location?: string,
    date?: string,
    buttonText?: string,
    hideButton?: boolean,
    finalized?: boolean,
    isPlanting?: boolean,
    seedlings?: any
}

const CampaignItem: React.FC<Props> = (props) => {
    let item = null;

    if (props.type == "big") {
        item = <IonCard className={`campaign-item ${props.type}`}>
            <IonCardContent>
                <Link to={props.link}>
                    <Image src={props.image} />

                    <IonText className="title">{props.title}</IonText>

                    <IonRow>
                        <IonCol className="current-price">
                            <div>محقق شده</div> <IonLabel>{props.currentPrice}</IonLabel>
                        </IonCol>
                        <IonCol className="target-price">
                            <div>هدف</div> <IonLabel>{props.targetPrice}</IonLabel>
                        </IonCol>
                    </IonRow>
                </Link>

                {props.isPlanting && <DownloadDoc id={props.id!} title={props.title!} small />}

                {!props.finalized ?
                    <Link to={{ pathname: `/campaign/${props.id}/donation` }}>
                        <IonButton expand="block" className={props.isPlanting ? "campaign-planting" : ""}>
                            <IonIcon slot="start" icon={props.isPlanting ? leafOutline : heartOutline} />
                            {props.isPlanting ? <IonText>اهدای نهال</IonText> : <IonText>حمایت می کنم</IonText>}
                        </IonButton>
                    </Link> :
                    <Link to={props.link}>
                        <IonButton expand="block" className="finalized">
                            <IonText>{props.buttonText === undefined ? "مشاهده پروژه" : props.buttonText}</IonText>
                        </IonButton>
                    </Link>}
            </IonCardContent>

            {/* {!props.finalized ? <ProgressBar width={props.progress + "%"} /> : null} */}
            <ProgressBar width={props.progress + "%"} />
        </IonCard>
    } else {
        item = <IonCard routerLink={props.link} button className={`campaign-item ${props.type}`}>
            <IonRow>
                <Image src={props.image} />

                <div className="text-section">
                    <IonText className="title">{props.title}</IonText>

                    <IonRow>
                        <IonCol className="current-price">
                            <div>محقق شده</div> <IonLabel>{props.currentPrice}</IonLabel>
                        </IonCol>
                        <IonCol className="target-price">
                            <div>هدف</div> <IonLabel>{props.targetPrice}</IonLabel>
                        </IonCol>
                    </IonRow>

                    <IonRow>
                        <IonCol size="7" className="location">
                            <IonIcon icon={locationOutline} /> <IonLabel>{props.location}</IonLabel>
                        </IonCol>
                        <IonCol size="5" className="date">
                            <IonIcon icon={calendarOutline} /> <IonLabel>{props.date}</IonLabel>
                        </IonCol>
                    </IonRow>


                    {!props.hideButton ?
                        <Link to={{ pathname: `/campaign/${props.id}/donation`, state: {title: props.title, isPlanting: props.isPlanting, seedlings: props.seedlings} }}>
                            {!props.finalized ?
                                <IonButton expand="block">
                                    <IonText>حمایت می کنم</IonText>
                                    <IonIcon slot="end" icon={chevronBack} />
                                </IonButton>
                                :
                                <IonButton expand="block" className="finalized">
                                    <IonText>{props.buttonText === undefined ? "مشاهده پروژه" : props.buttonText}</IonText>
                                </IonButton>
                            }
                        </Link> : null}
                </div>
            </IonRow>
        </IonCard>
    }

    return <>{item}</>
}

export default CampaignItem